// extracted by mini-css-extract-plugin
module.exports = {"customTable":"index_customTable__2dYxZ","selectionActions":"index_selectionActions__zXsKz","tableContainer":"index_tableContainer__2lO6C"};